import { render, staticRenderFns } from "./Expire.vue?vue&type=template&id=b8dd35f6&scoped=true&"
import script from "./Expire.vue?vue&type=script&lang=ts&"
export * from "./Expire.vue?vue&type=script&lang=ts&"
import style0 from "./Expire.vue?vue&type=style&index=0&id=b8dd35f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8dd35f6",
  null
  
)

export default component.exports